export enum Severities {
    success = 0, info = 1, warn = 2, error = 3
}
export enum LanguageKeys {
    en = 16,
    fr = 17,
    es = 84,
    ar = 194
}
export const CurrencySymbols = {
    USD: '$',
    GBP: '£',
    SGD: 'S$',
    EUR: '€',
    AED: 'AED',
    // AED: 'فلس',
    VND: '₫',
    MYR: 'RM',
    SAR: 'SR',
    INR: '₹',
    EGP: 'E£',
    BDT: 'BDT',
    MMK: 'MMK',
    PKR: 'PKR'

}
export enum RoleGroups {
    SiteAdmin = 1, CompanyAdmin = 2, VendorAdmin = 3, RegularUser = 4, InHouseTechnician = 5, FieldTechnician = 6
}
export enum CultureFormat {
    //'en-US' = 'mm/dd/yy', info = 1, warn = 2, error = 3
}

export enum Theme {
    Blue = 1,
    Pink = 148,
    Gray = 149,
    LightGray = 150,
    DarkBlue = 151,
    DarkPink = 209,
    DarkGreen = 222
}

export class FPMessage {
    Severity: Severities;
    MessageCode: string
    AdditionalInfo: string;    
}
export class FPResponse {
    Data: any;
    Message: FPMessage;
}
export class FPChatResponse {
    Data: number;
    Message: string;
    MessageCode: string;
}
export class JobStatus {
    JobStatusId: number;
    JobStatus: string;
}
export class GlobalInfo {
    CompanyId: number;
    LoginId: number;
    Email: string;
    DisplayName: string;
    Culture: string;
    Currency: string;
    LanguageId: number;
    CurrentLangId: number;
    Resource: string;
    ResourceLanguage: string;
    ResourceDefault: string;
    Roles: string[];
    ThemeId: string;
    CountryId: number;
    MaxRoleGroup: RoleGroups;
    VendorId: number;
    IsManager?: boolean;
    TimeZoneId: number;
    HomePageId: number;
    BusinessAddressId: number;
    Mpin: string;
    Managerid?: number;
    IsTech?: boolean;
    LogoPath: string;
    MapId: string;
    MapKey: string;
    ZoneId: number;
    IsLatLonBased: boolean;
    ProjectEnabled?: number;
    DefaultCountryId?: number;
    ReturnURL: string;
    LicenseExpired: string;
    PasswordExpired: string;
    CompanyCode: string;
    SpeechLang: string;
    // Added by Yogesh M on 21/08/2020 for Accessible Worktypes and regions start
    HasAccessToAllRegions: boolean;
    HasAccessToAllWorkTypes: boolean;
    ProductCategoryId: number;
    // Added by Yogesh M on 21/08/2020 for Accessible Worktypes and regions end
}

export class RoleAccess {
    ParentMenuId: number;
    MenuId: number;
    MenuName: string;
    UiPageName: string;
    ModuleId: number;
    ViewRights: number;
    AddRights: number;
    EditRights: number;
    DeleteRights: number;
    IsMenu: number;
}

export class ProductCategory{
    ProductCategoryId : number;
    CompanyId : number;
    ProductCategory : string;
    IsActive : number;
}
export class ContractType{
    ContractTypeId : number;
    CompanyId : number;
    ContractType : string;
    IsActive : number;
}


export class SaveProductCategory {
    ProductCategoryId : number;
    ProductCategory: string;
    CompanyId: number;
    Description: string;
    IsActive: number;
    CreatedBy: number;
    LastChangedBy: number;
    CreatedDate: string;
    LastUpdate:string;  

}

export class SaveContractType{
    ContractTypeId : number;
    ContractType: string;
    CompanyId: number;
    Description: string;
    IsActive: number;
    CreatedBy: number;
    LastChangedBy: number;
    CreatedDate: string;
    LastUpdate:string;  

}

export class PagerList {
    CompanyId: number;
    IsActive: number;
    SortBy: string;
    OrderBy: string;
    StartRecord: number;
    EndRecord: number;
    SearchBy: string;
}

//Deprecated
export class ResponseMessage {
    Id: string;
    Status: string;
}
export class Country {
    CountryId: number;
    CountryName: string;
}
export class PageKeyIds {
    ParentMenuId: PageKey;
    MenuId: PageKey;
}
export enum PageKey {
    //Admin
    Administration = 82,
    //Admin->Scheduling
    Administration_Scheduling = 115,
    Administration_Scheduling_Regions = 116,
    Administration_Scheduling_Zones = 117,
    Administration_Scheduling_Skills = 118,
    Administration_Scheduling_Certifications = 119,
    Administration_Scheduling_Holidays = 120,
    Administration_Scheduling_SchedulingPreferences = 121,
    Administration_Scheduling_TechnicianPreference = 272,

    //Admin->EmailSms
    Administration_EmailSms = 132,
    Administration_EmailSms_AutoEmailTemplates = 133,
    Administration_EmailSms_AutoSMSTemplates = 134,
    Administration_EmailSms_ManualEmailSMSTemplates = 135,

    //Admin->User & Technician
    Administration_UserTechnician = 83,
    Administration_UserTechnician_Users = 92,
    Administration_UserTechnician_Users_AssociatedVendor = 273,
    Administration_UserTechnician_Users_Warehouse = 326,
    Administration_UserTechnician_Technicians = 93,
    Administration_UserTechnician_Technicians_Regions = 94,
    Administration_UserTechnician_Technicians_Skills = 95,
    Administration_UserTechnician_Technicians_Certifications = 96,
    Administration_UserTechnician_Technicians_WorkType = 97,
    Administration_UserTechnician_Technicians_MailWorkingAddress = 98,
    Administration_UserTechnician_Roles = 99,
    Administration_UserTechnician_RolesPrivileges = 100,
    Administration_UserTechnician_Technicians_Warehouse = 274,
    Administration_UserTechnician_Technicians_Contact = 189,
    // Added by Yogesh M on 26/08/2020 for Accessible regions & worktypes Start
    Administration_UserTechnician_Users_Accessible_Region = 741,
    Administration_UserTechnician_Users_Accessible_WorkType = 742,
    // Added by Yogesh M on 26/08/2020 for Accessible regions & worktypes End

    //Admin->WorkOrder
    Administration_WorkOrder = 101,
    Administration_WorkOrder_Sla = 112,
    Administration_Checklist = 111,
    Administration_DynamicForms = 340,

    //Admin->Setup
    Administration_Setup = 122,
    Administration_Setup_SystemSettings = 123,
    Administration_Setup_CustomFields = 123,
    //Customer->CreateCustomer
    Customer = 2,
    Customer_CreateCustomer = 3,
    Customer_ManageCustomers = 11,
    Customer_CreateCustomer_Address = 4,
    Customer_CreateCustomer_BillingAccount = 5,
    Customer_CreateCustomer_Contacts = 6,
    Customer_CreateCustomer_Equipment = 7,
    Customer_CreateCustomer_PM = 8,
    Customer_CreateCustomer_SpecialInstruction = 9,
    Customer_CreateCustomer_RecentOrders = 10,
    Customer_CreateCustomer_BusinessHours = 275,
    Customer_TransferEquipment = 287,
    Customer_ProfilePhotos = 584,
    Customer_Associated_Vendors = 787,
    //Project-->Setup
    Project = 288,// 1000,
    Project_ManageProjects = 271,
    Project_Milestone = 812,
    Project_Scope = 280,
    Project_ProjectSettings = 287,
    Project_Attachments = 281,
    Project_Summary = 816,
    Project_SpecialandProjectNotes = 283,
    Project_Associatesites = 284,
    Project_Patners = 286,
    Project_Createproject = 1001,

    //Budget Plan 
    Project_BudgetPlan = 839,
    //ApprovalProcess
    Project_Approvals = 840,
    Project_SubmitForApproval = 841,
    // ustomer_CreateCustomer = 3,
    Customer_ManageCustomers_Address = 4,
    Customer_ManageCustomers_BillingAccount = 5,
    Customer_ManageCustomers_Contacts = 6,
    Customer_ManageCustomers_Equipment = 7,
    Customer_ManageCustomers_SpecialInstruction = 9,
    Customer_ManageCustomers_RecentOrders = 10,
    Customer_ManageCustomers_CustomerDetail = 182,
    Customer_ManageCustomers_TechnicianPreference = 237,

    //PM->
    PM_CreatePMSchedule = 13,
    PM_ManagePMSchedules = 14,
    PM_ManagePMSchedules_CustomerDetails = 15,
    PM_ManagePMSchedules_ScheduleLabourInformation = 16,
    PM_ManagePMSchedules_EquipmentInformation = 17,

    PM_CreateEPMSchedule = 239,
    PM_ManageEPMSchedule = 240,
    //added by rakesh
    Administration_SchedulingTemp = 12,
    Administration_Scheduling_PMTemplate = 344,


    //Technician
    Technician = 51,
    //Technician -> Availability
    Technician_TechnicianAvailability = 52,
    Technician_TechnicianAvailability_SetOrRemoveAvailability = 53,

    //In house Jobs
    In_House_Jobs_Queue = 191,
    In_House_Contact_Details = 192,
    In_House_Update_Status = 193,
    In_House_Technician_Remarks = 194,
    In_House_Special_Instruction = 195,
    In_House_Service_Notes = 196,
    In_House_Tech_Job_Details = 197,
    In_House_Equipment = 198,
    In_House_Job_History = 199,
    In_House_Attachments = 200,
    In_House_Checklists = 201,
    In_House_Signature = 202,
    In_House_Pricing = 203,
    In_House_Payment_Details = 204,
    In_House_Update_Status_Accept = 205,
    In_House_Update_Status_Completed = 206,
    In_House_Update_Status_Unresolved = 207,
    In_House_Map = 208,
    In_House_Payment = 209,
    In_House_Job_Info = 210,
    In_House_Job_PartRequest = 726,
    In_House_Job_BOQ_PartRequest = 727,
    In_House_JobApprovalStatus = 804,
    In_House_Job_SLA = 807,
    In_House_OtherInfo = 814,
    In_House_ProjectDetails = 815,


    //Technician->Technician Jobs
    Technician_TechnicianJobs = 54,
    Technician_TechnicianJobs_CustomerDetails = 55,
    Technician_TechnicianJobs_Map = 179,
    Technician_TechnicianJobs_UpdateStatus = 57,
    Technician_TechnicianJobs_TechnicianRemarks = 58,
    Technician_TechnicianJobs_SpecialInstruction = 59,
    Technician_TechnicianJobs_ServiceNotes = 60,
    Technician_TechnicianJobs_AdminNotes = 280,
    Technician_TechnicianJobs_JobDetails = 61,
    Technician_TechnicianJobs_Equipment = 62,
    Technician_TechnicianJobs_JobHistory = 63,
    Technician_TechnicianJobs_Attachments = 64,
    Technician_TechnicianJobs_Checklists = 65,
    Technician_TechnicianJobs_Signature = 66,
    Technician_TechnicianJobs_Pricing = 67,
    Technician_TechnicianJobs_PaymentDetails = 68,
    Technician_TechnicianJobs_PaymentPanel = 180,
    Technician_TechnicianJobs_EnRouteBtn = 175,
    Technician_TechnicianJobs_OnSiteBtn = 176,
    Technician_TechnicianJobs_CompleteBtn = 177,
    Technician_TechnicianJobs_UnResolveBtn = 178,
    Technician_TechnicianJobs_JobDetailView = 181,
    Technician_TechnicianJobs_PartRequest = 263,
    Technician_TechnicianJobs_BOQ_PartRequest = 459,
    Technician_TechnicianJobs_ProjectDetailsPanel = 647,
    Technician_TechnicianJobs_PunchPoints = 695,
    Technician_TechnicianJobs_ScheduleToMe = 696,
    Technician_JobApprovalStatus = 803,
    Technician_Job_SLA = 808,
    Technician_OtherInfo = 813,

    WORKORDER = 101,
    WORKORDER_ManageCustomerTypes = 114,
    WORKORDER_STATUSREASON = 113,
    WORKORDER_ClientPortalSettings = 330,

    Administration_EmailAndSMS = 132,
    Administration_ManualSMSEmailTemplate = 135,
    DISPATCH = 40,
    DISPATCH_DISPATCHBOARD = 41,
    DISPATCH_SEND_MANUAL_EMAIL_SMS = 50,
    //Schedule Optimization
    SCHEDULE_OPTIMIZATION = 238,
    BULK_SCHEDULING_QUEUE = 252,
    //ADMIN WORK ORDER MASTER
    //WORKORDERMASTERPARENT = 101,
    WORKORDERMASTER = 102,

    WORKORDERMASTER_CATEGORY = 103,
    WORKORDERMASTER_TYPE = 104,
    WORKORDERMASTER_REQUEST = 105,
    WORKORDERMASTER_SCHEDULING_PRICING = 106,
    WORKORDERMASTER_ATTACHMENT = 107,
    WORKORDERMASTER_CETRIFICATION = 108,
    WORKORDERMASTER_CHECKLIST = 109,
    WORKORDERMASTER_SKILL = 110,

    //ADMINISTRATION VENDOR
    ADMINVENDOR = 84,
    ADMINVENDOR_ATTACHMENTS = 85,
    ADMINVENDOR_CONTACTS = 86,
    ADMINVENDOR_PRICING = 87,
    ADMINVENDOR_REGION = 88,
    ADMINVENDOR_WORKTYPE = 89,
    ADMINVENDOR_LICENSE = 90,
    ADMINVENDOR_VENDORADMIN = 91,
    ADMINVENDOR_BOQPARTS = 452,

    //ADMINISTRATION COMPANY MASTER
    ADMINCOMPANY = 124,
    ADMINCOMPANY_BUSINESS_HOUR = 125,
    ADMINCOMPANY_APPLICATION_CONFIG = 126,
    ADMINCOMPANY_ADMIN_USER = 127,
    ADMINCOMPANY_THEME_LOGO = 128,
    ADMINCOMPANY_MASTER_ENTITY = 129,
    ADMINCOMPANY_BILLING_ADDRESS = 130,
    ADMINCOMPANY_CONTACT_ADDRESS = 131,
    ADMINCOMPANY_MAPPROVIDER = 231,

    //Quotes
    CREATE_QUOTE = 669,
    MANAGE_QUOTE_ORDERS = 670,
    //WORK ORDER
    WORK_ORDER = 18,
    WO_CREATE_QUICK_WO_CREATESITE = 837,
    WO_CREATE_QUICK_WO_PRICING = 833,
    WO_CREATE_QUICK_WO_EQUIPMENT = 834,
    WO_CREATE_QUICK_WO_SPECIALINS = 836,
    WO_CREATE_QUICK_WO_SERVICENOTES = 835,
    WO_CREATE_QUICK_WORK_ORDER = 699,
    WO_CREATE_WORK_ORDER = 19,
    WO_MANAGE_WORK_ORDERS = 20,
    MANAGE_WO_CUSTOMER_DETAILS = 21,
    MANAGE_WO_RECENT_ORDER_HISTORY = 22,
    MANAGE_WO_SERVICE_ADDRESS = 23,
    MANAGE_WO_BILLING_ACCOUNT = 24,
    MANAGE_WO_SERVICE_CONTACT = 25,
    MANAGE_WO_BILLING_CONTACT = 183,
    MANAGE_WO_SPECIAL_INSTRUCTION = 26,
    MANAGE_WO_SERVICE_NOTES = 27,
    MANAGE_WO_EQUIPMENT = 28,
    MANAGE_WO_JOB_DETAILS = 29,
    MANAGE_WO_SCHEDULE_APPOINTMENT = 30,
    MANAGE_WO_AUTO_SCHEDULE_APPOINTMENT = 31,
    MANAGE_WO_CANCEL_APPOINTMENT = 32,
    MANAGE_WO_CANCEL_JOB = 33,
    MANAGE_WO_DELETE_JOB = 34,
    MANAGE_WO_PRINT_JOB = 35,
    MANAGE_WO_ATTACHMENTS = 36,
    MANAGE_WO_RESERVATION = 37,
    MANAGE_WO_PRICING = 38,
    MANAGE_WO_VIEW_EMAIL_SMS_LOG = 39,
    MANAGE_WO_PART_REQUEST = 262,
    MANAGE_WO_ADMIN_NOTES = 279,
    MANAGE_ASSIGN_VENDOR = 295,
    MANAGE_CUSTOMER_WO = 335,
    MANAGE_BOQ_PART_REQUEST = 458,
    PROJECT_DETAILS_PANEL = 646,
    MANAGE_WO_SLA = 806,

    QUOTES = 694,
    MANAGE_QUOTES = 670,
    MANAGE_WORKITEMS_DETAILS = 677,
    MANAGE_QUOTES_CUSTOMER_DETAILS = 671,
    MANAGE_QUOTES_DETAILS = 676,
    MANAGE_QUOTES_SERVICE_ADDRESS = 672,
    MANAGE_QUOTES_BILLING_ACCOUNT = 673,
    MANAGE_QUOTES_SERVICE_CONTACT = 674,
    MANAGE_QUOTES_BILLING_CONTACT = 675,
    MANAGE_QUOTES_EQUIPMENT = 681,
    MANAGE_QUOTES_PART = 682,
    MANAGE_QUOTES_ATTACHMENT = 691,
    MANAGE_QUOTES_AUDIT_LOG = 683,
    MANAGE_QUOTES_PRICING = 678,
    MANAGE_QUOTES_SPECIAL_INSTRUCTION = 679,
    MANAGE_QUOTES_SERVICE_NOTES = 680,
    MANAGE_QUOTES_ADMIN_NOTES = 692,
    MANAGE_VENDOR_COST = 786,
    MANAGE_QUOTES_ASSIGN_VENDOR = 795,
    MANAGE_DELETE_WORKITEM = 796,

    MANAGE_WO_PAYMENT = 187,
    Audit_Log = 188,

    //Custom fields
    MANAGE_CUSTOM_FIELDS = 226,
    CUSTOM_FIELD_DETAILS = 227,
    CUSTOM_FIELD_SCREENS = 228,
    CLIENT_PORTAL_LOGIN = 333,
    //Approval Queus
    Approval_QueueDetail = 211,
    Approval_Checklists = 220,
    Approval_Attachments = 219,
    Approval_Equipment = 218,
    Approval_Payment = 217,
    Approval_VendorCost = 216,
    Approval_CustomerPricing = 215,
    Approval_RevertApproval = 809,
    Approval_ApproveJob = 213,
    Approval_RejectJob = 809,
    Approval_BulkRejectJob = 811,
    Approval_BulkApproveJob = 212,
    
    Approval_WorkRequestDetails = 221,
    Approval_roleBulkApprovalJobsfromListView = 212,
    Approval_AdminNotes = 281,
    Approval_ServiceNotes = 286,
    Approval_TechRemarks = 285,
    Approval_PartRequest = 300,
    Approval_BOQ_PartRequest = 460,
    Approval_ProjectDetailsPanel = 648,
    Approval_PunchPoint = 697,
    Approval_Feedbackpanel = 817,

    //Invoice Ques
    Invoice_Queue = 233,
    Invoice_Queues = 40,
    Invoice_SingleInvoice = 234,
    Invoice_MultipleInvoice = 235,
    Invoice_RevertApproval = 236,
    Invoice_InvoiceQueue = 233,
    Invoice_PartRequest = 301,


    //Live Map 
    LiveMap = 222,
    LiveMap_StatusBased = 223,
    LiveMap_GPSBased = 224,
    LiveMap_GPSHistory = 225,

    //Inventory Report
    INVENTORY_REPORT = 265,
    INVENTORY_REPORT_ADJUSTMENT = 266,
    //Inventory
    INVENTORY = 242,
    INVENTORY_STOCK_REQUEST = 254,
    INVENTORY_STOCK_REQUEST_APPROVAL = 255,
    INVENTORY_STOCK_REQUEST_CANCEL = 256,
    INVENTORY_PART_REQUEST = 270,
    INVENTORY_CORE_RETURN = 269,
    INVENTORY_STOCK_RECEIPT_ISSUE = 260,
    INVENTORY_BOQ_Approval_Queue = 453, // Added by Yogesh M on 06/05/2020 for BOQ Approval Queue Approve / Reject Role issue

    //Insight
    INS_PROJECT_IMPORT = 1002,
    Assign_Vendor = 1007,
    ICC_Queue = 1003,
    ICC_Technician_Screening = 1004,
    ICC_Technician_Confirmation = 1005,
    ICC_Site_Confirmation = 1006,

    //Work Order Report
    Work_Order_Report = 264,
    WO_Summary_Report = 249,
    WO_Customer_Report = 250,
    WO_SLA_Report = 251,
    WO_Customer_feedback_Report = 283,
    Wo_Agreement_Invoice_Report = 294,
    Tech_Utilization_Report = 296,
    Status_Reason_Report = 298,
    Wo_Pricing_Details_Report = 337,

    //Stock Tranfer
    Stock_Tranfer = 257,
    Stock_Cancel = 259,
    Stock_Tranfer_Inven = 242,
    Stock_Approve = 258,

    //Inventory Adjustment
    Adjustment_save = 253,
    Inventory_Adjustment = 242,

    //Inventory Lists
    Manage_Brands = 243,
    Manage_Model = 244,
    Manage_Warehouse = 245,
    Manage_Location = 246,
    Manage_Bin = 247,
    Manage_part = 248,
    Inventory_List = 278,
    Manage_partcategory = 325,
    //Dashboards
    PowerBI = 306,
    //Import Work Order
    IMPORT_WORKORDER = 327,
    IMPORT_MASTER = 345,
    //IOT
    IOT_ALERT = 346,
    LIST_IOT_ALERT = 347,
    //EdotCo - Specific Components Start 
    EDOTCO_REPORT = 339,
    EDOTCO_CHECKLIST_REPORT = 4201,
    //EdotCo - Specific Components Start 
    //Vendor Approval
     VendorApproval_Menuid = 797,
     VendorApproval_JobApprovalStatusPanel = 798 ,
     VendorApproval_VendorCost = 799,
     VendorApproval_Approval = 800,
     VendorApproval_Reject = 801,
     ApprovalQueue_Reject_Job = 809
     
}

export class carousal {
    mode: string = "";
    id: number = 0;
    type: any;
    index: number;
}
export class carousaladdress {
    index: number = 0;
    primary: any = 0;
    header: string = "";
    detail: string = "";
    isPrimary: boolean = false;
}

export class SystemSetting {
    SettingId: number;
    Setting: string;
    SettingValue: string;
    SettingUnit: string;

}
export enum SourceSystem {
    Web = 1,

}
export enum Distance {
    VMILE = 0, VKM = 1
}

export class ConfigSettings {
    ConfigDtlId: number;
    Description: string;
}
export class AttachmentsModel {
    CompanyId: number;
    ModelId: number;
    CreatedBy: number;
    Description: string;
    AttachmentType: string
    FileName: string;
    ModelAttachmentId: number;
    Attachment: string;
    DocType: boolean;
    DocThumbImage: string;
}
export class ImageModel {
    ImageId: number;
    FileName: string;
    Description: string;
    AttachmentId: number;
    Attachment: string;
    Tag: string;
    TagId?: number;
    FilePath: string;
}
export class TagModel {
    Tag: string;
    TagId?: number;
}
export class ConversationMessage {
    Identity: string;
    ConversationSid: string;
    Message: string;
}

export class MapView {
    UserLat: number;
    UserLon: number;
    ZipLat: number;
    ZipLon: number;
    MapLat: number;
    MapLon: number;

    AddresLine1: string;
    AddresLine2: string;
    Cityame: string;
    ZipCode: string;
    Country: string;
}

export class NewNumber {
    Number: string;
    ConversationSid: string;

}
export class NewGroup {
    Numbers: string;
    ConversationSid: string;
    Groupname: string;

}

export class ProjectDetailsPanelEntity {
    ProjectName: string;
    CustomerType: string;
    PMName: string;
    BusinessOwner: string;
    PC: string;
    ProjectType: string;
    ProjectStatus: string;
    WBSno: string;
    ProjectStartDate: string;
    ProjectEndDate: string;
    ProjectMilestone: String;
    RegionalTechLead: String;
}
export class QOStatusCompEntity {
    QOStatusId: number;
    QOStatus: string;
    IsActive: number;

}
export class ChecklistFileDetail {
    workorderId: number;
    companyId: number;
    woJobid: number;
    FileName: string;
    //  orderTypeId: number;
    ChklistMastId: number;
    chklistdltid: number;
}
export class ChecklistAttachmetDt {
    componentName: string;
    isAttchmentUploaded: boolean;
    uploadedFile: any[];
    woJobid: number;
    orderTypeId: number;
    ChklistMastId: number;
    chklistdltid: number;
}

export class QuoteStatusReasonEntity {
    StatusReasonId: number;
    CompanyId: number;
    QOStatusId: number;
    StatusReason: string;
    Description: string;
    IsActive: number;
    IsDefault: number;
    CreatedBy: number;
    CreatedDate: string;
    LastUpdate: string;
    LastChangedBy: number;
}
export class ChecklistFileDetails {
    workorderId: number;
    companyId: number;
    woJobid: number;
    FileName: string;
    chklistdltid: number;


}

export class AttachmentCategoryandTag {
    ConfigMasterEntity: Titles[];
    ReoRefAttachmentSubCategoryEntity: ReoRefAttachmentSubCategory[];
}
export class Titles {
    ConfigDtlId: number;
    ConfigMasterId: number;
    Description: string;
}
export class ReoRefAttachmentSubCategory {
    SubCategoryId: number;
    CompanyId: number;
    AttachmentSubCategory: string;
    Description: string;
    TypeId: number;
    EnableAddImageIntegration: number;
    IsActive: number;
}
export class CompanyMaster {
    CompanyId: number;
    CompanyName: string;
    ShortName: string;
    Phone: string;
    Fax: string;
    Email: string;
    Website: string;
    UnitNo: string;
    CityName: string;
    StateId: number;
    ZipCode: string;
    CountryId: number;
    StateName: string;
    CountryName: string;
    Status: any;
    IsActive: number;
    PrimaryContactName: string;
    AddressLine1: string;
    AddressLine2: string;
    StateShortName: string;
    Address: string;

    LicenseValidUpto: string;
    LicenseAlertBefore: number;
    DefaultLocaleId: number;
    DefaultLanguageId: number;
    DefaultCurrencyId: number;
    DefaultCountryId: number;
    DefaultThemeId: number;
    Edition: any;
    EditionId: number;
    EnableOptimization: number;
    EnableMultiVendor: number; //Added by Anvardeen Batcha
    IsProjectEnabled: number; //Added by Anvardeen Batcha
    EnableMultiVendorShrTech: number; //Added by Anvardeen Batcha
    EnableJobVendorSwitch: number; //Added by Anvardeen Batcha
    IsTaxEnabled: number; //Added by Anvardeen Batcha
    MaxUsers: number;
    MaxWoLicense: number;

    CreatedBy: number;
    CreatedDate: string;
    LastChangedBy: number;
    LastUpdate: string;
    VendorId: number;

    LogoPath: string;
    ChklistLogoPath: string;
    ChkListHeaderPath: string;
    ChkListFooterPath: string;
    PrintoutLogoPath: string;
    PrintoutHeaderPath: string;
    PrintOutFooterPath: string;
    WeekEnd: any; // region As discussed with vijay TN  company based weekend implemented  // Added/ Modified by Anvardeen Batcha B

    DefaultLanguageIds: number[];
    IsLatLonBased: number;
    DefaultCountryIds: number[];
    EnableWorkType: number;
    JobCompletionOTPRequired: number;
    IsPolygonRegion: number;
    IsClientPortalEnabled: number;
    EnablePartRequestApproval: number;
    EnableVendorBOQ: number;
    IsLinkWorkOrderEnabled: number;
    IsQuoteEnabled: number;
    OTPTypeId?: number;
    EnablePreferVendorForCustomer?:number;
}
export class ProjectEntity {
    ProjectId: number;
    CompanyId: number;
    ProjectName: string;
    WBSno: string;
    CustomerType: string;
    CreatedDate: string;
    PMName: string;
    PC: string;
    BusinessOwner: string;
    ProjectTypeId: number;
    ProjectStatus: number;
    ProjectStartDate: string;
    ProjectEndDate: string;
    ProjectDuration: string;
    RegionalTechLead: string;
    Scope: string;
    CreatedBy: number;
    CostCenter: string;
    Description: string;
    // public CustomerTypeId: string[] = [];
    CustomerTypeId: string;
    ProjectStatusId: number;
    LastChangedBy: number;
    LastUpdate: string;
    ProjectStatusText: string;
    OTPTypeId: number;
    JobCompletionOTPRequired: number;
}
// Added for Edotco Specific by KP on 14/08/20
export class SerialNoDetails {
    SerialNo: string;
    ExpiryDate: string;

}

export enum OTPType {
    SenttoCustomer = 412,
    SenttoTechnician = 413,
    Manuallygeneratedbydispatcher = 414
}
export class JobStatusColorCode {
    JobStatusCompId: number;
    CompanyId: number;
    JobStatusId: number;
    JobStatus: string;
    IsActive: number;
    CreatedBy: number;
    CreatedDate: Date;
    LastChangedBy: number;
    LastUpdate: Date;
    OrderBy: number;
    IsReasonRequired: number;
    IsMobileStatus: number;
    MasterJobStatus: string;
    ColorCode: string;
}
export class WoStatusColorCode {
    WoStatusCompId: number;
    CompanyId: number;
    WoStatusId: number;
    WoStatus: string;
    IsActive: number;
    CreatedBy: number;
    CreatedDate: Date;
    LastChangedBy: number;
    LastUpdate: Date;
    MasterWoStatus: string;
    ColorCode: string;
}
export class QOStatusColorCode {
    QOStatusCompId: number;
    CompanyId: number;
    QOStatusId: number;
    QOStatus: string;
    IsActive: number;
    CreatedBy: number;
    CreatedDate: Date;
    LastChangedBy: number;
    LastUpdate: Date;
    MasterQOStatus: string;
    ColorCode: string;
}
export class Logo {
    fileName: string;
    filePath: string;
    attachment: string;
}
export class JobStatusPopupInputSearchEntity {
    CompanyId: number;
    WoJobId: string;
    TrackId?: number;
}
export class ResponseJobStatusPopupList {
    jobStatuPopupEntityList: JobStatusPopupEntity[];
    jobStatuPopuplatlanList: JobStatusLatLanEntity[];
}
export class JobStatusLatLanEntity {
    lat: string;
    lng: string;
    trackid: number;
}
export class JobStatusPopupEntity {
    WoJobId: number;
    WoNumber: string;
    ScheduleStartDateCtz: string;
    WoCategory: string;
    WorkType: string;
    WorkTask: string;
    DisplayName: string;
    Phone1: string;
    PhotoPath: string;
    WorkStartsLat: string;
    WorkStartsLong: string;
    CustomerLat: string;
    CustomerLong: string;
    ScheduleTime: string;
    OnSiteDate: string;
    OnSiteTime: string;
    EnRouteDate: string;
    EnRouteTime: string;
    CompletedDate: string;
    CompletedTime: string;
    JobStatus: string;
}
export class Direction {
    fromaddress: string;
    toaddress: string;
    fromlat: string;
    fromlon: string;
    tolat: string;
    tolon: string;
}
